import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { SubTabBar } from '../SubTabBar';
import { CopyConfigModal } from '../CopyConfigModal';
import { NewSubsPage } from './compact/NewSubsPage';
import { OnlinePage } from './compact/OnlinePage';

interface AutomatedMessagesTabProps {
  accountId: string;
  /** Show only this part, without the sub-tab bar (the sidebar's separate pages). */
  only?: 'setup' | 'online';
}

export function AutomatedMessagesTab({ accountId, only }: AutomatedMessagesTabProps) {
  const { t } = useTranslation('automatedMessages');
  const [searchParams, setSearchParams] = useSearchParams();
  const subTab = only ?? (searchParams.get('asub') === 'online' ? 'online' : 'setup');
  const [showCopy, setShowCopy] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const subTabs = [
    { id: 'setup', label: t('tab.setup'), icon: 'user-plus' },
    { id: 'online', label: t('tab.online'), icon: 'radio' },
  ];

  const handleSubTabChange = (id: string) => {
    const current = Object.fromEntries(searchParams.entries());
    setSearchParams({ ...current, asub: id });
  };

  return (
    <div>
      {!only && <SubTabBar tabs={subTabs} active={subTab} onChange={handleSubTabChange} />}

      {subTab === 'setup' && <NewSubsPage key={`${accountId}-${refreshKey}`} accountId={accountId} onCopy={() => setShowCopy(true)} />}
      {subTab === 'online' && <OnlinePage key={accountId} accountId={accountId} />}

      <CopyConfigModal
        type="automated"
        currentAccountId={accountId}
        isOpen={showCopy}
        onClose={() => setShowCopy(false)}
        onComplete={() => setRefreshKey((k) => k + 1)}
      />
    </div>
  );
}
